module.exports = __webpack_public_path__ + "img/marker_four_green3.34c743d6.png";